import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDisclosure,
  useHotkeys,
  useIsFirstRender,
  useMediaQuery,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconCaretDown,
  IconCheck,
  IconClipboardX,
  IconFileExport,
  IconFileUpload,
  IconPackageExport,
  IconPrinter,
  IconSearch,
  IconStatusChange,
  IconTruck,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_ColumnVirtualizer,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, {
  useDeferredValue,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
  typeGv,
} from "../../../_base/_const/_constVar";
import {
  DefaultMemoizedCell,
  DefaultMemoizedCellDate,
} from "../../../_base/_const/baseHook";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { beige, green, navy_blue, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDelivery } from "../../../model/TblDelivery";
import {
  getBranchSelectMdm,
  getDeliveryStatusSelectMdm,
} from "../../../service/getSelectApi";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import CancelGHTKAndAhamove from "../Delivery/CancelGHTKAndAhamove";
import { printGhtkLabel } from "./printGhtkLabel";
// Ensure this file exists at the specified path or update the path to the correct location

const GHTKAndAhamoveDelivery = () => {
  const [valueTypeGet, setValueTypeGet] = useState<string | null>("");
  // Reference data from another table
  const navigate = useNavigate();
  const [dataTblDeliveryStatusSelect, setDataTblDeliveryStatusSelect] =
    useState<ComboboxItem[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);

  const dataShippingUnit = [
    { label: "GHTK", value: "3" },
    { label: "Ahamove", value: "2" },
  ];
  const firstRender = useIsFirstRender();
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDelivery[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDelivery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  //table state
  const [rowCount, setRowCount] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15,
  });
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //  const [opened, { open, close }] = useDisclosure(false);
  const [orderCode, setOrderCode] = useState("");

  const [search, setSearch] = useState({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ).getTime() +
              7 * 60 * 60 * 1000
          ).toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    deliveryDepartmentId:
      _searchJson && checkedPinSearch ? _searchJson?.deliveryDepartmentId : "",
    statusId: _searchJson && checkedPinSearch ? _searchJson?.statusId : [],
    branchId: _searchJson && checkedPinSearch ? _searchJson?.branchId : [],
    customerId: _searchJson && checkedPinSearch ? _searchJson?.customerId : "",
    customerProvinceId:
      _searchJson && checkedPinSearch ? _searchJson?.customerProvinceId : "",
    customerDistrictId:
      _searchJson && checkedPinSearch ? _searchJson?.customerDistrictId : "",
    customerCommuneId:
      _searchJson && checkedPinSearch ? _searchJson?.customerCommuneId : "",
    type: _searchJson && checkedPinSearch ? _searchJson?.type : "",
    empid: _searchJson && checkedPinSearch ? _searchJson?.empid : "",
    sourceType: _searchJson && checkedPinSearch ? _searchJson?.sourceType : [],
    sourceCode: _searchJson && checkedPinSearch ? _searchJson?.sourceCode : "",
    transactionNumber:
      _searchJson && checkedPinSearch ? _searchJson?.transactionNumber : "",
    shippingUnit:
      _searchJson && checkedPinSearch ? _searchJson?.shippingUnit : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 2, xl: 2 };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      // {
      //   accessorKey: "fromBranchName",
      //   header: "Chi nhánh đi",
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue }) => (
      //     <DefaultMemoizedCell value={renderedCellValue} />
      //   ),
      // },
      {
        accessorKey: "sourceCode",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => {
                if (renderedCellValue?.toString()?.includes("DH")) {
                  handleCheckView(row);
                } else {
                  return;
                }
              }}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
        enableColumnFilter: false,
        size: 160,
      },
      {
        accessorKey: "toAddress",
        header: "Địa chỉ giao hàng",
        Cell: ({ row }) => (
          <Text fw={500} size="11.5px">
            {row.original.toAddress?.replace(/^(undefined|null) - /, "")}
          </Text>
        ),
        enableColumnFilter: false,
        size: 450,
      },
      {
        accessorKey: "description",
        header: "Ghi chú đơn hàng",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "debt",
        header: "Công nợ",
        Cell: ({ row }) => (
          <Text fw={500} size="11.5px">
            {row.original.sourceType === 1 && row.original.debt === null
              ? "Thu tiền ngay"
              : row.original.debt}
          </Text>
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "createByName",
        header: "Nhân viên tạo đơn hàng",
        // Cell: ({ renderedCellValue }) => (
        //   <AvatarUtils
        //     value={renderedCellValue?.toString() ?? ""}
        //     sizeXS={true}
        //   />
        // ),
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "amountTotal",
        header: "Tiền phải thu",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && renderedCellValue !== "0"
              ? `${Number(renderedCellValue)?.toLocaleString()} đ`
              : "0 đ"}
          </>
        ),
      },
      {
        accessorKey: "attribute1",
        header: "Đơn vị vận chuyển",
        size: 200,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color={renderedCellValue === "GHTK" ? "#00EE36" : "#FF7F32"}>
              {renderedCellValue}
            </Badge>
          ) : (
            <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2B3276", deg: 90 }}
            >
              Nội bộ
            </Badge>
          ),
      },
      {
        accessorKey: "attribute46",
        header: "Trạng thái giao hàng",
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorStatus(
              getValueById(
                renderedCellValue?.toString() ?? "",
                dataTblDeliveryStatusSelect,
                "label"
              )
            )}
            radius={"sm"}
            size="xs"
          >
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataTblDeliveryStatusSelect,
              "label"
            )}
          </Badge>
        ),
        size: 225,
        enableColumnFilter: false,
      },
      {
        accessorKey: "sourceType",
        header: "Nguồn hàng",
        Cell: ({ row }) => (
          <Badge
            color={getColorSourceType(row.original.sourceType)}
            radius={"sm"}
            size="xs"
          >
            {soureTypeText(row.original.sourceType)}
          </Badge>
        ),
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "subInvName",
        header: "Kho",
        enableColumnFilter: false,
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "customerName",
        header: "Khách hàng",
        size: 140,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "telephoneNumber",
        header: "Số điện thoại",
        enableColumnFilter: false,
        size: 140,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "transactionFinishDate",
        header: "Ngày xuất kho",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "transactionContent",
        header: "Nội dung giao",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      // {
      //   accessorKey: "action",
      //   header: "Thao tác",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   enableColumnFilter: false,
      //   enableResizing: false,
      //   enableClickToCopy: false,
      //   size: 70,
      //   Cell: ({ row }) => (
      //     <ActionIcon
      //       variant="light"
      //       color="red"
      //       disabled={row.original.attribute46 !== "261"}
      //       onClick={() => {
      //         if (row.original.attribute1 === "Ahamove") {
      //           modalsCancelGHTKAndAhamove("Ahamove", row.original.sourceCode, row.original.id);
      //         } else if (row.original.attribute1 === "GHTK") {
      //           modalsCancelGHTKAndAhamove("GHTK", row.original.sourceCode, row.original.id);
      //         }
      //       }}
      //     >
      //       <IconClipboardX />
      //     </ActionIcon>
      //   ),
      // },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableResizing: false,
        enableClickToCopy: false,
        size: 70,
        Cell: ({ row }) =>
          row.original.attribute1 === "GHTK" ? (
            // Số chứng từ gốc là mã đã gửi sang GHTK lúc tạo đơn
            <Tooltip label="In nhãn GHTK">
              <ActionIcon
                variant="light"
                color="indigo"
                aria-label="In nhãn GHTK"
                onClick={() => printGhtkLabel(row.original.sourceCode)}
              >
                <IconPrinter size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          ) : (
            <></>
          ),
      },
    ],
    [deleteViewStatus, dataTblDeliveryStatusSelect]
  );

  useEffect(() => {
    setDefault();
    if (firstRender) {
      fetchDataBranchSelect();
    }
    console.log(dataBranchSelect);
  }, []);

  const modalsCancelGHTKAndAhamove = (
    type: string,
    sourceCode: string,
    id: number
  ) => {
    modals.openConfirmModal({
      title: (
        <Title order={5}>
          {type === "GHTK" ? "Hủy đơn GHTK" : "Hủy đơn Ahamove"}
        </Title>
      ),
      size: "auto",
      children: (
        <CancelGHTKAndAhamove
          type={type}
          sourceCode={sourceCode}
          onSuccess={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const setDefault = async () => {
    if (
      _searchJson &&
      _searchJson?.valueTypeGet?.length > 0 &&
      checkedPinSearch
    ) {
      setValueTypeGet(_searchJson?.valueTypeGet);
    } else {
      const res = await repositoryDelivery.get<MessageResponse<string>>(
        `/api/v1/TblDelivery/get-default-gv?type=VD`
      );
      if (res && res.httpStatusCode === 200) {
        // await fetchData(res.data);

        startTransition(() => {
          setValueTypeGet(res.data);
        });
      }
    }
  };
  function getColorSourceType(value: number) {
    switch (value) {
      case 1:
        return beige.base;
      case 2:
        return sky_blue.light_alt;
      case 3:
        return navy_blue.base;
      case 4:
        return "#7b2eda";
      case 5:
        return "#C91A52";
    }
  }

  function getColorStatus(value: string) {
    switch (value) {
      case "Đã phân công":
        return "lime";
      case "Lập đơn giao hàng":
        return "green";
      case "Đang giao hàng":
        return "teal";
      case "Đơn hàng giao chưa thành công do Khách hàng":
        return "blue";
      case "Đơn hàng giao chưa thành công do Hacom":
        return "indigo";
      case "Hàng đã giao":
        return "violet";
      case "Hủy phân công":
        return "red";
      case "Đã đến nơi":
        return "#2bdd66";
      case "Nối chuyến":
        return "yellow";
      case "Hủy đơn":
        return "#c91a25";
      case null:
      case undefined:
      case "":
        return "rgba(0, 0, 0, 0)";
    }
  }

  const soureTypeText = (numberST: number) => {
    switch (numberST) {
      case 1:
        return "Đơn hàng";
      case 2:
        return "Điều chuyển";
      case 3:
        return "Khác";
      case 4:
        return "Xuất bảo hành";
      case 5:
        return "Xuất trả khách";
    }
  };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.sourceCode.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.sourceCode,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.sourceCode,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      }
    }
  };
  const [isPending, startTransition] = useTransition();

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    startTransition(() => {
      if (value !== "Invalid date")
        setSearch((prevData) => ({ ...prevData, [key]: value }));
      else {
        setSearch((prevData) => ({ ...prevData, [key]: "" }));
      }
    });
  };

  const optionColorsAccount: Record<
    | "Đã phân công"
    | "Lập đơn giao hàng"
    | "Đang giao hàng"
    | "Đã đến nơi"
    | "Đơn hàng giao chưa thành công do Khách hàng"
    | "Đơn hàng giao chưa thành công do Hacom"
    | "Hàng đã giao"
    | "Hàng đã giao - nối chuyến"
    | "Hủy phân công"
    | "Nối chuyến"
    | "Hủy đơn",
    string
  > = {
    "Đã phân công": "lime",
    "Lập đơn giao hàng": "green",
    "Đang giao hàng": "teal",
    "Đã đến nơi": "cyan",
    "Đơn hàng giao chưa thành công do Khách hàng": "blue",
    "Đơn hàng giao chưa thành công do Hacom": "indigo",
    "Hàng đã giao": "violet",
    "Hàng đã giao - nối chuyến": "grape",
    "Hủy phân công": "red",
    "Hủy đơn": "#c91a25",
    "Nối chuyến": "yellow",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Đã phân công"
              | "Lập đơn giao hàng"
              | "Đang giao hàng"
              | "Đã đến nơi"
              | "Đơn hàng giao chưa thành công do Khách hàng"
              | "Đơn hàng giao chưa thành công do Hacom"
              | "Hàng đã giao"
              | "Hàng đã giao - nối chuyến"
              | "Hủy phân công"
              | "Hủy đơn"
              | "Nối chuyến"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorSourceType: Record<
    "Đơn hàng" | "Điều chuyển" | "Khác" | "Xuất bảo hành" | "Xuất trả khách",
    string
  > = {
    "Đơn hàng": "#E2E2B6",
    "Điều chuyển": "#6EACDA",
    Khác: "#03346E",
    "Xuất bảo hành": "#7b2eda",
    "Xuất trả khách": "#C91A52",
  };

  const renderSelectOptionSourceType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorSourceType[
            option.label as
              | "Đơn hàng"
              | "Điều chuyển"
              | "Khác"
              | "Xuất bảo hành"
              | "Xuất trả khách"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorShippingUnit: Record<"Nội bộ" | "GHTK" | "Ahamove", string> =
    {
      "Nội bộ": "linear-gradient(90deg, #EA242A 0%, #2B3276 100%)",
      GHTK: "#00EE36",
      Ahamove: "#FF7F32",
    };

  const renderSelectOptionShippingUnit: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorShippingUnit[option.label as "Nội bộ" | "GHTK" | "Ahamove"]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const dataDeliveryStatusSelect = async () => {
    try {
      const getData = await getDeliveryStatusSelectMdm();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblDeliveryStatusSelect(mappedData);
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const fetchDataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataBranchSelect(
      getData
        .filter(
          (item) =>
            item.value != null && item.text != null && item.value !== "-1"
        )
        .map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  const fetchData = async (typeGet?: string, noti?: string) => {
    // if (!valueTypeGet) {
    //   NotificationExtension.Fails("Vui lòng chọn bộ phận !");
    //   return;
    // }
    setIsLoading(true);
    setIsRefetching(true);
    startTransition(() => {
      setIsError(false);
      setData([]);
      setRowCount(0);
    });
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }&IsPartnerDeliveried=true`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.statusId.length > 0) {
      url += search.statusId.map((item: any) => `&StatusId=${item}`).join("");
    }

    if (search.branchId.length > 0) {
      url += search.branchId.map((item: any) => `&BranchId=${item}`).join("");
    }

    if (search.customerId) {
      url += `&CustomerId=${search.customerId}`;
    }

    if (search.sourceType.length > 0) {
      url += search.sourceType
        .map((item: any) => `&SourceType=${item}`)
        .join("");
    }

    if (search.sourceCode) {
      url += `&SourceCode=${search.sourceCode}`;
    }

    if (search.transactionNumber) {
      url += `&TransactionNumber=${search.transactionNumber}`;
    }

    if (search.shippingUnit.length > 0) {
      url += `&ShippingUnit=${search.shippingUnit}`;
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      let urlPrefix = generateUrlPrefix(typeGet);
      const response = await repositoryDelivery.get(`${urlPrefix}${url}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();

        if (noti) {
          NotificationExtension.Success(noti);
        }
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      if (dataTblDeliveryStatusSelect) setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          valueTypeGet: valueTypeGet,
        })
      );
    }

    function generateUrlPrefix(typeGet?: string) {
      let urlPrefix = "/api/v1/TblDelivery/get-list";
      const checkType = typeGet ? typeGet : valueTypeGet;
      switch (checkType) {
        case "1":
          urlPrefix = urlPrefix + "-gv";
          break;
        case "2":
          urlPrefix = urlPrefix + "-ktkt";
          break;
        case "3":
          urlPrefix = urlPrefix + "-da";
          break;
        case "4":
          urlPrefix = urlPrefix + "-kttc";
          break;
        default:
          break;
      }
      return urlPrefix;
    }
  };

  const handleExportData = async () => {
    open();
    try {
      const getName = typeGv.find((x) => x.value === valueTypeGet)?.label;
      let url =
        `/api/v1/TblDelivery/export-deliveries?IsPartnerDeliveried=true&Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}&DeliveryDepartment=` + getName;

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.statusId.length > 0) {
        url += search.statusId.map((item: any) => `&StatusId=${item}`).join("");
      }

      if (search.branchId.length > 0) {
        url += search.branchId.map((item: any) => `&BranchId=${item}`).join("");
      }

      if (search.customerId) {
        url += `&CustomerId=${search.customerId}`;
      }

      if (search.sourceType.length > 0) {
        url += search.sourceType
          .map((item: any) => `&SourceType=${item}`)
          .join("");
      }

      if (search.sourceCode) {
        url += `&SourceCode=${search.sourceCode}`;
      }

      if (search.transactionNumber) {
        url += `&TransactionNumber=${search.transactionNumber}`;
      }

      if (search.shippingUnit.length > 0) {
        url += `&ShippingUnit=${search.shippingUnit}`;
      }

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_muc_don_giao_hang_dieu_van" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleCancelDelivery = async (id: any, type: string) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDelivery/cancel-deliveries",
      {
        ids: id,
        type: type,
      }
    );

    if (res) {
      if (type === "HUY_PHAN_CONG") {
        NotificationExtension.Success("Hoàn tất hủy phân công !");
      } else {
        NotificationExtension.Success("Hoàn tất hủy đơn hàng !");
      }
      setTimeout(() => {
        modals.closeAll();
        setDeleteViewStatus(!deleteViewStatus);
      }, 1000);
    }
  };

  const handlePushOrder = async () => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/OrderHeader/push-order-header-to-delivery",
      {
        orderCode: orderCode,
      }
    );

    if (res && res.success) {
      setOrderCode("");
      NotificationExtension.Success("Đã cập nhật đơn giao hàng !");
      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const height = useDynamicHeight(175);

  useEffect(() => {
    if (!firstRender) {
      fetchData();
      dataDeliveryStatusSelect();
    }
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    deleteViewStatus,
    valueTypeGet,
  ]);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);
  const deferredValueselectIds = useDeferredValue(selectIds);
  useEffect(() => {
    startTransition(() => {
      const numericIds = deferredValueselectIds.map((id) => Number(id));

      const filtered = data.filter((item) =>
        numericIds.includes(Number(item.id))
      );
      const filteredDSN = filtered?.map((item: any) => item.deliveryStatusName);
    });
  }, [deferredValueselectIds]);
  const columnVirtualizerInstanceRef = useRef<MRT_ColumnVirtualizer>(null);
  const table = useMantineReactTable({
    columns,
    data,
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 2 }, //optionally customize the virtualizer
    enableColumnResizing: true,
    enableColumnVirtualization: true,
    enableClickToCopy: true,
    enableTopToolbar: false,
    enableRowNumbers: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    enableExpandAll: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    // enableRowSelection: (row) =>
    //   row.original.deliveryStatusName === "Lập đơn giao hàng" ||
    //   row.original.deliveryStatusName === "Hủy phân công" ||
    //   row.original.deliveryStatusName ===
    //     "Đơn hàng giao chưa thành công do Khách hàng" ||
    //   row.original.deliveryStatusName ===
    //     "Đơn hàng giao chưa thành công do Hacom" ||
    //   row.original.deliveryStatusName === "Nối chuyến",
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers", "sourceCode"],
        right: ["action"],
      },
      columnVisibility: {
        id: false,
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height / 1.15, minHeight: height / 1.15 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["15", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onDoubleClick: () => {
    //     detailProduct(
    //       row.original.id,
    //       row.original.sourceType,
    //       row.original.sourceCode
    //     );
    //   },
    //   sx: { cursor: "pointer" },
    // }),
  });
  useHotkeys([["Enter", async () => await fetchData()]]);

  return (
    <>
      <div ref={headerRef} style={{ width: "100%" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Flex
            gap="md"
            justify={{ sm: "flex-end", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={() => handleExportData()}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <Flex gap={"md"} align={"center"} wrap={"wrap"} mb={10} mt={10}>
          <Grid gutter={"xs"} w={"100%"}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                placeholder="Nhập từ khóa"
                defaultValue={keySearch}
                leftSection={<IconSearch color="#15aabf" />}
                onChange={(e) => setKeySearch(e.currentTarget.value)}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Từ ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.startDate.length > 0
                    ? new Date(search.startDate ?? "")
                    : null
                }
                onChange={(e) => {
                  handleChangeSearchValue(
                    e ? formatDateNotTimeZone(e ?? "") : "",
                    "startDate"
                  );
                }}
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Đến ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.endDate.length > 0
                    ? new Date(search.endDate ?? "")
                    : null
                }
                onChange={(e) => {
                  handleChangeSearchValue(
                    e ? formatDateNotTimeZone(e ?? "") : "",
                    "endDate"
                  );
                }}
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Chi nhánh - Địa điểm nhận hàng"
                data={dataBranchSelect}
                value={
                  search?.branchId && search?.branchId?.length > 0
                    ? search?.branchId
                    : []
                }
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                onChange={(e) => {
                  handleChangeSearchValue(e ? e : [], "branchId");
                }}
                onClick={() => {
                  if (dataBranchSelect.length === 0) {
                    fetchDataBranchSelect();
                  }
                }}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Nguồn hàng"
                data={[
                  { label: "Đơn hàng", value: "1" },
                  { label: "Điều chuyển", value: "2" },
                  { label: "Khác", value: "3" },
                  { label: "Xuất bảo hành", value: "4" },
                  { label: "Xuất trả khách", value: "5" },
                ]}
                value={
                  search?.sourceType && search?.sourceType?.length > 0
                    ? search?.sourceType
                    : []
                }
                leftSection={<IconPackageExport color="#15aabf" />}
                onChange={(e) =>
                  handleChangeSearchValue(e ? e : [], "sourceType")
                }
                clearable
                renderOption={renderSelectOptionSourceType}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Trạng thái"
                clearable
                data={dataTblDeliveryStatusSelect}
                value={
                  search?.statusId && search?.statusId?.length > 0
                    ? search?.statusId
                    : []
                }
                leftSection={<IconStatusChange color="#15aabf" />}
                onChange={(e) => {
                  handleChangeSearchValue(e ? e : [], "statusId");
                }}
                renderOption={renderSelectOptionStatus}
                comboboxProps={{ width: 400 }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Bộ phận"
                // defaultValue={keySearch}
                leftSection={<IconSearch color="#15aabf" />}
                data={typeGv}
                value={valueTypeGet}
                onChange={setValueTypeGet}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Đơn vị vận chuyển"
                clearable
                data={dataShippingUnit}
                value={search?.shippingUnit}
                leftSection={<IconTruck color="#15aabf" />}
                renderOption={renderSelectOptionShippingUnit}
                onChange={(e) =>
                  handleChangeSearchValue(e ? e : "", "shippingUnit")
                }
              />
            </Grid.Col>
            <Grid.Col span={{ base: 6, sm: 4, md: 3, lg: 0.8, xl: 0.8 }}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={() => {
                  fetchData();
                }}
                disabled={isPending}
                w={"100%"}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Flex>
      </div>
      <MantineReactTable table={table} />
    </>
  );
};

export default GHTKAndAhamoveDelivery;
